import { render, staticRenderFns } from "./UsageLogsComponent.vue?vue&type=template&id=f0bfaa90&scoped=true&"
import script from "./UsageLogsComponent.vue?vue&type=script&lang=js&"
export * from "./UsageLogsComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsageLogsComponent.vue?vue&type=style&index=0&id=f0bfaa90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bfaa90",
  null
  
)

export default component.exports